import { PureComponent } from 'react'
import styled from 'glamorous'
import { withRouter } from 'react-router-dom'
import Switch from 'react-router-dom/Switch'
import Route from 'react-router-dom/Route'
import { graphql, compose } from 'react-apollo'
import range from 'lodash/range'
import filter from 'lodash/filter'
import { $, getLocationQuery, getUrlSearch, getError } from 'utils'
import { Button, InnerLayout, EmptyDetails, PaginationBar } from 'components'
import { TOKENS as query, CreateTokenMutation } from 'queries'
import { withConsumer } from 'store'

import TokensList from './TokensList'
import DetailsPage from './DetailsPage'

const Header = styled.div({
  display: 'flex',
  justifyContent: 'space-between'
})

const HeaderButtons = styled.div({
  display: 'flex'
})

export class Tokens extends PureComponent {

  createToken = () => this.props.mutate({
    variables: { tokenData: '' },
    update: (proxy, { data: { createToken } }) => {
      const variables = getVariables(getLocationQuery(this.props.location))
      const data = proxy.readQuery({ query, variables })
      data.account.tokens.items = [{
        __typename: "Token",
        uuid: createToken.token.uuid,
        tokenData: createToken.token.tokenData,
      }, ...data.account.tokens.items ]
      data.account.tokens.items = filter(data.account.tokens.items, (item, i) => i < variables.limit)
      data.account.tokens.count += 1
      proxy.writeQuery({ query, data, variables })
    }
  }).then(({ data }) => this.props.history.push({
    pathname: `/tokens/${data.createToken.token.uuid}`,
    search: window.location.search
  }))
    .catch(error => this.props.setErrorMessage(getError(error)))

  changePage = (value) => {
    const { history, location, data: { variables: vars } } = this.props
    const search = getUrlSearch({...vars, offset: value})
    history.push({
      pathname: location.pathname,
      search,
    })
  }

  render = () => {
    const { data: { loading, account, variables: vars } } = this.props
    const tokens = account && account.tokens ? account.tokens.items : []
    const pagesCount = account && account.tokens ? Math.ceil(account.tokens.count / (vars.limit || 10)) : 0
    const paginationOptions = range(1, pagesCount + 1)

    return (
      $(InnerLayout,
        $(Header,
          $(PaginationBar, {
            name: 'Tokens',
            options: paginationOptions,
            value: vars.offset || 1,
            onChange: this.changePage,
            from: pagesCount,
          }),
          $(HeaderButtons,
            $(Button, {
              bgColor: 'var(--violet)',
              width: 124,
              primary: true,
              onClick: this.createToken,
            }, 'Add token'),
          ),
        ),
        $(TokensList, { tokens, loading }),
        $(Switch,
          $(Route, {
            path: `/tokens/:id`,
            render: () => $(DetailsPage)
          }),
          $(Route, {
            path: `/tokens`,
            component: EmptyDetails
          }),
        )
      )
    )
  }
}

export default withRouter(
  compose(
    graphql(CreateTokenMutation),
    graphql(query, {
      options: props => {
        const queryParams = getLocationQuery(props.location)
        return {
          fetchPolicy: 'cache-and-network',
          variables: getVariables(queryParams)
        }
      }
    })
  )(withConsumer(Tokens))
)

const getVariables = (queryParams) => ({
  limit: +queryParams.limit || 10,
  offset: +queryParams.offset || 1,
})


// WEBPACK FOOTER //
// ./src/pages/Tokens/index.js